import { SignInPanel } from '@/features/auth';

export function SignInPage() {
  return <SignInPanel />;
}
